export default class DateHelper {
    public static DateTimeNowAddHours(date: Date, hours: number): Date {
        date.setHours(date.getHours() + hours);

        return date;
    }

    public static DateTimeFromUnixTimestamp(unixTimestamp: number): Date {
        return new Date(unixTimestamp * 1000);
    }

    public static GetHourAndMinuteFromDate(date: Date): string {
        let dateText = date.toTimeString();
        dateText = dateText.split(" ")[0];
        const dateTextClockArr = dateText.split(":");
        return `${dateTextClockArr[0]}:${dateTextClockArr[1]}`;
    }

    public static GetHourAndMinuteFromUnixTimespanDate(timespan: number): string | undefined {
        if (timespan) {
            const date = new Date(timespan * 1000);
            let dateText = date.toTimeString();
            dateText = dateText.split(" ")[0];
            const dateTextClockArr = dateText.split(":");
            return `${dateTextClockArr[0]}:${dateTextClockArr[1]}`;
        } else return undefined;
    }

    public static GetDayNameFromUnixTimespanDate(dateTimespan: number): string {
        const date = new Date(dateTimespan * 1000);
        return date.toLocaleDateString("PL-pl", {weekday: "long"});
    }

    public static GetDateTimeNowAsUnixTimespan(): number {
        return Math.floor(Date.now() / 1000);
    }

    public static GetActualTimeForInputDate(): string {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Miesiące są 0-indeksowane
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    }

    public static GetDateTimeNowWithMinutesAndSecundesSetOnZeroAsUnixTimestamp(): number {
        const dateNow = new Date();
        dateNow.setMinutes(0, 0, 0);
        return Math.floor(dateNow.getTime() / 1000);
    }

    public static DateNowUnixTimestamp(): number {
        const dateNow = new Date();
        dateNow.setHours(0, 0, 0, 0);
        return Math.floor(dateNow.getTime() / 1000);
    }

    public static DateTimeNowUnixTimestamp(): number {
        const dateNow = new Date();
        return Math.floor(dateNow.getTime() / 1000);
    }

    public static GetTempDateAsUnixTimespan(): number {
        const dateNow = new Date();
        const dateToSet = new Date(
            2024,
            1,
            13,
            dateNow.getHours(),
            dateNow.getMinutes(),
            dateNow.getSeconds()
        );
        return Math.floor(dateToSet.getTime() / 1000);
    }

    public static DateTimeFormatForEpgDetails(datetime: Date): string {
        return `${("0" + (datetime.getDate())).slice(-2)}.${(
            "0" +
            (datetime.getMonth() + 1)
        ).slice(-2)}, godz. ${("0" + datetime.getHours()).slice(-2)}:${(
            "0" + datetime.getMinutes()
        ).slice(-2)}`;
    }

    public static DateTimeToUnixTimestamp(datetime: Date): number {
        if (!(datetime instanceof Date)) {
            throw new TypeError("Argument must be a Date object");
        }

        return Math.floor(datetime.getTime() / 1000);
    }

    public static UnixTimestampToDateTime(unixTimestamp: number): Date {
        return new Date(unixTimestamp * 1000);
    }

    public static hasDaylightSavingTimeChangedLast7Days() {
        const today = new Date();
        const offsets = [];

        // Sprawdź przesunięcie UTC dla każdego dnia z ostatnich 7 dni
        for (let i = 0; i < 7; i++) {
            const date = new Date(today);
            date.setDate(today.getDate() - i);
            offsets.push(date.getTimezoneOffset());
        }

        // Jeśli są różne wartości w offsets, to nastąpiła zmiana czasu
        return new Set(offsets).size > 1;
    }

    public static getLastDSTTransitionTimestampAndType(): {
        unixTimestamp: number,
        changeToType: "summer" | "winter" | null
    } {
        const today = new Date();

        // Sprawdź przesunięcie UTC dla każdego dnia z ostatnich 7 dni
        for (let i = 0; i < 7; i++) {
            const date = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 3, 0, 0, 0);
            const currentDate = new Date(date);
            currentDate.setDate(today.getDate() - i);
            const dateMinus1Day = new Date(currentDate);
            dateMinus1Day.setDate(currentDate.getDate() - 1);
            const currentDateOffset = currentDate.getTimezoneOffset();
            const dateMinus1DayOffset = dateMinus1Day.getTimezoneOffset();
            if (currentDateOffset !== dateMinus1DayOffset) {
                if (currentDate.getMonth() + 1 === 10) {
                    return {changeToType: "winter", unixTimestamp: this.DateTimeToUnixTimestamp(currentDate)};
                } else if (currentDate.getMonth() + 1 === 3) {
                    currentDate.setHours(2, 0, 0, 0);
                    return {changeToType: "summer", unixTimestamp: this.DateTimeToUnixTimestamp(currentDate)};
                }
            }
        }
        return {changeToType: null, unixTimestamp: 0};
    }
}
